import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CiamApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CiamApiModule {
    public static forRoot(configurationFactory: () => CiamApiConfiguration): ModuleWithProviders<CiamApiModule> {
        return {
            ngModule: CiamApiModule,
            providers: [ { provide: CiamApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CiamApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CiamApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
